import { FC, useContext } from 'react';
import BasicCard from '../common/BasicCard';
import BasicModal from '../common/BasicModal';
import { useTranslation } from 'react-i18next';
import { CampaignContext } from '../../contexts/CampaignContext';

type IAddPostModal = {
	open: boolean;
	onClose: () => void;
	handleClickPost: (val: any) => () => void;
	handleClickStory: (val: any) => () => void;
};

const AddPostModal: FC<IAddPostModal> = ({ open, onClose, handleClickPost, handleClickStory }) => {
	const { t } = useTranslation();
	const { selectedContentType, selectedPlatform, selectedMediaTypeId, selectedPlatformId, fetchedMedias } = useContext(CampaignContext);

	let filterMedia = fetchedMedias?.find(item => item.id === selectedPlatformId);
	let filterMediaType = filterMedia?.types.find(item => item.id === selectedMediaTypeId);
	const isPost = selectedContentType === 'post';
	let filterSystemName = filterMediaType?.sub_types.filter(item => item.system_name.includes(isPost ? 'post' : 'story'));
	return (
		<BasicModal
			className={`h-auto ${isPost && selectedPlatform === 'instagram' ? 'max-w-[25%]' : filterSystemName && filterSystemName?.length >= 3 ? 'max-w-[75%]' : 'max-w-[50%]'}`}
			open={open}
			onClose={onClose}
			titleKey="add_post_modal_title"
			titleValues={{
				contentType: t(selectedContentType as string),
			}}
		>
			<div className="flex w-full gap-x-4 pt-8">
				{isPost && selectedPlatform === 'instagram' ? (
					<>
						<BasicCard paperClasses="h-96 w-full" descriptionClasses="line-clamp-none leading-6" buttonClasses="w-full self-end" color="secondary" title={t('raw_post')} subject={t('what_is_raw_post')} description={t('raw_post_description')} onClick={handleClickPost('raw_post')} />
					</>
				) : (
					filterSystemName?.map((item, index) => (
						<>
							<BasicCard paperClasses="h-96 w-1/2" descriptionClasses="line-clamp-none leading-6" buttonClasses="w-full self-end" color={`${index % 2 === 0 ? 'primary' : 'secondary'}`} title={item.title} subject={`${item.title} ${t('what')} ؟ `} description={item.description} onClick={isPost ? handleClickPost(item.system_name) : handleClickStory(item.system_name)} />
						</>
					))
				)}
			</div>
		</BasicModal>
	);
};

export default AddPostModal;
